import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { About } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function about(config) {
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(About)),
    });
    return Object.freeze({
        /**
         * Get information about this CodeGrade instance.
         *
         * @param arg The arguments to the function.
         * @param arg.health Key required to view instance health information.
         * @param arg.tenantId The id of the tenant to get the site settings for.
         * @returns The about object for this instance.
         */
        get: async ({ health = undefined, tenantId = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/about`, getResponse.v, undefined, {
                health,
                tenant_id: tenantId,
            });
            return result;
        },
    });
}
